import { StatusBadge } from '@/components/common/StatusBadge';
import {
  FEEDBACK_COMPLETION_LABEL,
  FEEDBACK_COMPLETION_TONE,
} from '../constants/feedback.constants';
import type { FeedbackStatus } from '../types/feedback.types';
import { getFeedbackCompletion } from '../utils/feedbackStatus';

interface FeedbackCompletionBadgeProps {
  status: FeedbackStatus;
}

export function FeedbackCompletionBadge({ status }: FeedbackCompletionBadgeProps) {
  const completion = getFeedbackCompletion(status);
  return (
    <StatusBadge tone={FEEDBACK_COMPLETION_TONE[completion]}>
      {FEEDBACK_COMPLETION_LABEL[completion]}
    </StatusBadge>
  );
}
